import type { ParamMatcher } from '@sveltejs/kit';
import { INVESTOR_RIGHTS_TYPE } from '$lib/consts';
/**
 * Checks if a given parameter string is a valid investor rights type.
 *
 * @param param - The string to check against the `INVESTOR_RIGHTS_TYPE` values.
 * @returns `true` if the parameter is a valid investor rights type, `false` otherwise.
 */
export const match: ParamMatcher = (param: string): boolean =>
	Object.values(INVESTOR_RIGHTS_TYPE).includes(param);
